import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetChallengeInsightProgressTimeInCallsSummaryApplicationService } from '../../../core/application/services/challenge-insights/get-challenge-insight-progress-time-in-calls-summary.application-service';
import { ChallengeInsightProgressTimeInCallsSummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-time-in-calls.aggregate-root';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';

export class GetChallengeInsightProgressTimeInCallsSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetChallengeInsightProgressTimeInCallsSummaryApplicationService
  ) {}
  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<ChallengeInsightProgressTimeInCallsSummaryAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
